var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qx-card',{attrs:{"title":"列表"}},[_c('LogRightDialog',{ref:"logRightDialog",attrs:{"busiCode":"3000012"}}),_c('section',{attrs:{"slot":"titleRight"},slot:"titleRight"},[_c('qx-permpisions',{attrs:{"permpisions":"7000701"}},[_c('ExportBtn',{attrs:{"len":_vm.tableData.data.length,"queryUrl":"vehicleServiceBO.ajax?cmd=doQueryAccidentList","params":_vm.fullSearchData,"bizName":"车辆事故信息导出","bizCode":"exp100054","excelKeys":_vm.excelKeys,"excelLables":_vm.excelLables}})],1),_c('qx-permpisions',{attrs:{"permpisions":"7000702"}},[_c('el-button',{attrs:{"type":"primary","plain":""},on:{"click":function () { return _vm.toEdit(null, '1'); }}},[_c('i',{staticClass:"iconfont"},[_vm._v("")]),_vm._v("新增\n      ")])],1),_c('qx-permpisions',{attrs:{"permpisions":""}},[_c('TableSetting',{model:{value:(_vm.tableData.title),callback:function ($$v) {_vm.$set(_vm.tableData, "title", $$v)},expression:"tableData.title"}})],1)],1),_c('section',{staticClass:"tablePage"},[_c('section',{ref:"tableBox",staticClass:"tableBox"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.tableData.loading),expression:"tableData.loading"}],ref:"multipleTable",attrs:{"data":_vm.tableData.data,"tooltip-effect":"dark","height":_vm.tableHeight},on:{"select":_vm.handleSelectionChange,"select-all":_vm.handleSelectionChange}},[_vm._l((_vm.tableData.title),function(item,index,key){return [(item.show)?_c('el-table-column',{key:key,attrs:{"prop":item.prop,"label":item.label,"sortable":item.sortable,"filters":item.filters,"filter-method":item.filterHandler,"min-width":item.minW,"width":item.w,"fixed":item.fixed},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _c('section',{},[(scope.column.property === 'plateNumber')?_c('section',{on:{"click":function($event){return _vm.toCarDetail(scope.row)}}},[_c('span',{staticClass:"primary cur"},[_vm._v("\n                  "+_vm._s(scope.row[scope.column.property])+"\n                ")])]):(scope.column.property === 'busiCode')?_c('section',{on:{"click":function($event){return _vm.toBusiCodeDetail(scope.row)}}},[_c('span',{staticClass:"primary cur"},[_vm._v("\n                  "+_vm._s(scope.row[scope.column.property])+"\n                ")])]):_c('section',[_c('span',[_vm._v(_vm._s(scope.row[scope.column.property]))])])])}}],null,true)}):_vm._e()]}),_c('el-table-column',{attrs:{"prop":"control","label":"操作","fixed":"right","width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('TableBtn',{attrs:{"tableData":scope.row,"btnList":[
                {
                  name: '查看',
                  event: function () { return _vm.toEdit(scope.row, '-1'); },
                },
                {
                  permpisions: '7000703',
                  name: '修改',
                  event: function () { return _vm.toEdit(scope.row, '0'); },
                },
                {
                  permpisions: '1002050501',
                  showCondition:
                    (scope.row.busiCode === '' ||
                      scope.row.busiCode === null) &&
                    scope.row.accidentState > 0 &&
                    scope.row.accidentState === 1,
                  name: '取消登记',
                  event: function () { return _vm.toCancel(scope.row); },
                },
                {
                  permpisions: '1002050503',
                  showCondition:
                    (scope.row.busiCode === '' ||
                      scope.row.busiCode === null) &&
                    scope.row.accidentState > 0 &&
                    scope.row.accidentState === 2,
                  name: '取消定损',
                  event: function () { return _vm.toCancel(scope.row); },
                },
                {
                  permpisions: '1002050504',
                  showCondition:
                    (scope.row.busiCode === '' ||
                      scope.row.busiCode === null) &&
                    scope.row.accidentState > 0 &&
                    scope.row.accidentState === 3,
                  name: '取消维修',
                  event: function () { return _vm.toCancel(scope.row); },
                },
                {
                  permpisions: '1002050505',
                  showCondition:
                    (scope.row.busiCode === '' ||
                      scope.row.busiCode === null) &&
                    scope.row.accidentState > 0 &&
                    scope.row.accidentState === 4,
                  name: '取消核赔',
                  event: function () { return _vm.toCancel(scope.row); },
                },

                {
                  permpisions: '1002050502',
                  showCondition: scope.row.accidentState === 1,
                  name: '定损',
                  event: function () { return _vm.toEdit(scope.row, '2'); },
                },
                {
                  permpisions: '1002050506',
                  showCondition: scope.row.accidentState === 2,
                  name: '维修',
                  event: function () { return _vm.toEdit(scope.row, '3'); },
                },
                {
                  permpisions: '1002050507',
                  showCondition:
                    scope.row.accidentState >= 2 &&
                    scope.row.accidentState < 4,
                  name: '核赔',
                  event: function () { return _vm.toEdit(scope.row, '4'); },
                },
                {
                  name: '日志',
                  event: function () { return _vm.showLog(scope.row.id); },
                } ]}})]}}])})],2)],1),_c('section',{staticClass:"paginationBox clearPa"},[_c('section',{staticClass:"right"},[_c('el-pagination',{attrs:{"current-page":_vm.tableData.page,"page-sizes":[10, 20, 50],"page-size":_vm.tableData.count,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.tableData.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }